




































import { Component, Vue } from 'vue-property-decorator';

import ErrorKuspitAccountInProcessOfValidationViewModel
  from '@/vue-app/view-models/components/contract-savings/creating-account/error-kuspit-account-in-process-of-validation-view-model';

@Component({
  name: 'ErrorKuspitAccountInProcessOfValidation',
})
export default class ErrorKuspitAccountInProcessOfValidation extends Vue {
  view_model = Vue.observable(
    new ErrorKuspitAccountInProcessOfValidationViewModel(this),
  );
}
